import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@chakra-ui/react';
import { Header, Footer } from '../../';

const Layout = ({ children, headerComponents, contentProps, ...containerProps }) => {
  return (
    <Flex flexDirection="column" height="100vh" {...containerProps} bgColor="white">
      <Header>{headerComponents}</Header>
      <Box flexGrow={1} {...contentProps}>
        {children}
      </Box>
      <Footer />
    </Flex>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  headerComponents: PropTypes.any,
  contentProps: PropTypes.object,
};

Layout.defaultProps = {};

export default Layout;
